import { useMpProductsFiltersStore } from '../stores/mpProductsFiltersStore';

export const useMpProductsFilters = () => {
  const filters = useMpProductsFiltersStore((state) => state.filters);
  const setFilters = useMpProductsFiltersStore((state) => state.setFilters);
  const updateFilters = useMpProductsFiltersStore(
    (state) => state.updateFilters
  );
  const setFilter = useMpProductsFiltersStore((state) => state.setFilter);
  const removeFilter = useMpProductsFiltersStore((state) => state.removeFilter);
  const clearFilters = useMpProductsFiltersStore((state) => state.clearFilters);
  const getFilter = useMpProductsFiltersStore((state) => state.getFilter);
  const hasFilters = useMpProductsFiltersStore((state) => state.hasFilters());
  const hasFilter = useMpProductsFiltersStore((state) => state.hasFilter);

  return {
    filters,
    setFilters,
    updateFilters,
    setFilter,
    removeFilter,
    clearFilters,
    getFilter,
    hasFilters,
    hasFilter,
  };
};
